
import { Component, OnInit, PLATFORM_ID, Inject, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { isPlatformBrowser } from '@angular/common';
import { AppConfigService } from './config/app-config.service';
import { AuthService } from './core/services/auth/auth.service';
import { CURRENT_ENV } from './config/env-config';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, FormsModule, ToastrModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {

  private auth = inject(AuthService);

  private isBrowser: boolean;

  constructor(
    private configService: AppConfigService,
    private authService: AuthService,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {

    // Runs on every refresh — logs out if permissions are missing
    // for the current session user
    if (this.auth.isLoggedIn()) {
      this.auth.checkPermissionsOrLogout();
    }

    if (CURRENT_ENV !== 'qa' && CURRENT_ENV !== 'prod') {
     // console.log('🌐 Connected Environment:', this.configService.getEnv());
      //console.log('🔗 API Base URL:', this.configService.getApiBaseUrl());
    }
    // Only restore permissions in browser to avoid hydration issues
    if (this.isBrowser) {
      // Restore permissions immediately - no delay needed
      this.authService.restorePermissions();
    } else {
      if (CURRENT_ENV !== 'qa' && CURRENT_ENV !== 'prod') {
        // Server-side: just call without storage access
       // console.log('Server-side initialization - skipping permission restoration');
      }
    }
  }
}